import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import MatrixRain from './MatrixRain';
import WaveText from './WaveText';

const tshirtGallery = [
  {
    img: '/tshirt_ragazzo.png',
    label: 'Lui — Studio Editorial',
  },
  {
    img: '/tshirt_ragazza.png',
    label: 'Lei — Street Style',
  },
  {
    img: '/tshirt_gruppo.png',
    label: 'La Crew — Community',
  },
];

const MerchSection = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goToSlide = useCallback((idx) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setActiveSlide(idx);
    setTimeout(() => setIsTransitioning(false), 600);
  }, [isTransitioning]);

  useEffect(() => {
    const timer = setInterval(() => {
      goToSlide((activeSlide + 1) % tshirtGallery.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [activeSlide, goToSlide]);

  const items = [
    { name: 'T-Shirt </AI_covo.tech>® genZ', featured: true, belt: 'Cintura Blu — 15€', desc: 'Total black. Logo </AI_covo.tech>® sul cuore + genZ sul petto. Stile All Blacks.' },
    { name: 'Canotta Gym', belt: 'Cintura Blu — 15€', desc: 'Dry-fit nera, </AI_covo.tech>® sul petto, genZ sulla schiena' },
    { name: 'Shorts Gym', belt: 'Cintura Blu — 15€', desc: 'Quick-dry nero, </AI_covo.tech>® sulla gamba sinistra' },
    { name: 'Costume Mare', belt: 'Cintura Rossa — 25€', desc: 'Boxer nero, </AI_covo.tech>® in verde Matrix sul fianco' },
    { name: 'Telo Mare', belt: 'Cintura Rossa — 25€', desc: 'Nero con </AI_covo.tech>® gigante verde al centro, 180x90cm' },
    { name: 'Cuffia Piscina Dark', belt: 'Cintura Gialla — 10€', desc: 'Silicone nero, </AI_covo.tech>® verde — versione Matrix' },
    { name: 'Cuffia Piscina Light', belt: 'Cintura Gialla — 10€', desc: 'Silicone bianca, </AI_covo.tech>® terracotta — versione istituzionale' },
    { name: 'Cuscino Spiaggia', belt: 'Cintura Gialla — 10€', desc: 'Gonfiabile nero, </AI_covo.tech>® stampato, ultra compatto' },
    { name: 'Cuscino Letto', belt: 'Cintura Rossa — 25€', desc: 'Memory foam, federa nera con </AI_covo.tech>® ricamato verde' },
    { name: 'Scaldacollo', belt: 'Cintura Gialla — 10€', desc: 'Pile nero, </AI_covo.tech>® termosaldato in verde' },
    { name: 'Guanti Bike', belt: 'Cintura Rossa — 25€', desc: 'Tessuto tecnico nero, grip </AI_covo.tech>® palmo, touchscreen' },
    { name: 'Accendino', belt: 'Cintura Arancione — 5€', desc: 'Metal finish nero, incisione </AI_covo.tech>® laser verde' },
    { name: 'Cinturino Smart Watch', belt: 'Cintura Gialla — 10€', desc: 'Silicone/gomma nero, buckle con </AI_covo.tech>® inciso' },
    { name: 'Penna', belt: 'Cintura Arancione — 5€', desc: 'Penna elegante nera, clip con </AI_covo.tech>® inciso' },
    { name: 'Penna USB 32GB', belt: 'Cintura Rossa — 25€', desc: 'Scocca nera, connettore USB-C, logo </AI_covo.tech>® verde' },
    { name: 'Block Notes', belt: 'Cintura Gialla — 10€', desc: 'Copertina soft-touch nera, </AI_covo.tech>® in rilievo verde' },
    { name: 'Cover Smartphone', belt: 'Cintura Gran Maestro — 100€+', desc: 'Silicone opaco nero, </AI_covo.tech>® retro in verde Matrix' },
    { name: 'Cover Tablet', belt: 'Cintura Gran Maestro — 100€+', desc: 'Custodia nera, </AI_covo.tech>® grande sulla cover esterna' },
  ];

  const currentPhoto = tshirtGallery[activeSlide];

  return (
    <section data-testid="merch-section" className="py-24 border-t border-white/10 relative overflow-hidden">
      <MatrixRain opacity={0.04} speed={0.6} />
      <div className="max-w-6xl mx-auto px-6">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4 text-center">&lt;/ Merchandising Esclusivo</p>
        <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-4 text-center">
          Linea <span className="text-[#00FF41] font-mono">&lt;/</span> Total Black
        </h2>
        <div className="max-w-2xl mx-auto text-center mb-4">
          <div className="inline-block px-5 py-2 rounded-lg border border-[#FF6B35]/40 bg-[#FF6B35]/5 mb-4">
            <p className="text-[#FF6B35] font-black text-sm" data-testid="merch-non-vendita">NON IN VENDITA</p>
          </div>
          <p className="text-zinc-400 text-sm mb-2">
            Il merchandising <span className="text-[#00FF41] font-mono font-bold">&lt;/AI_covo.tech&gt;®</span> non si compra. Si <strong className="text-white">sblocca</strong>.
          </p>
          <p className="text-zinc-500 text-xs">
            Ogni articolo è riservato ai <strong className="text-white">soci tesserati</strong> che sostengono il progetto con una donazione.
            Dona, diventa socio, scegli il tuo premio. Niente store, niente e-commerce — solo community.
          </p>
        </div>

        {/* T-Shirt Featured Gallery */}
        <div className="max-w-2xl mx-auto mb-12 mt-10" data-testid="tshirt-gallery">
          <div className="bg-[#0A0A0A] border-2 border-[#00FF41]/30 rounded-2xl overflow-hidden hover:border-[#00FF41]/60 transition-all duration-500">
            {/* Gallery viewport */}
            <div className="relative aspect-[3/4] md:aspect-[4/5] bg-black overflow-hidden">
              {tshirtGallery.map((photo, idx) => (
                <div
                  key={idx}
                  className="absolute inset-0 transition-all duration-700 ease-in-out"
                  style={{
                    opacity: activeSlide === idx ? 1 : 0,
                    transform: activeSlide === idx ? 'scale(1)' : 'scale(1.08)',
                  }}
                >
                  <img
                    src={photo.img}
                    alt={`T-Shirt </GEN... — ${photo.label}`}
                    className="w-full h-full object-cover"
                    loading={idx === 0 ? 'eager' : 'lazy'}
                  />
                  {/* Dark gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20" />

                  {/* Logo </AI_covo.tech>® + genZ — sul petto */}
                  <div className="absolute bottom-[18%] left-[15%] z-20 flex flex-col items-start pointer-events-none">
                    <span className="font-mono font-black text-xs sm:text-sm md:text-base" style={{
                      color: '#00FF41',
                      WebkitTextStroke: '0.5px rgba(0,0,0,0.9)',
                      paintOrder: 'stroke fill',
                      textShadow: '0 0 14px rgba(0,255,65,0.6), 0 0 30px rgba(0,255,65,0.2)',
                      filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.8))',
                    }}>&lt;/AI_covo.tech&gt;<sup style={{ fontSize: '0.5em', verticalAlign: 'super', fontFamily: 'Georgia, serif', fontWeight: 400 }}>&reg;</sup></span>
                    <span className="font-mono text-[6px] sm:text-[7px] text-white/60 tracking-[0.15em] mt-0" style={{ textShadow: '0 1px 4px rgba(0,0,0,0.9)' }}>DIGITAL HUB SOCIALE</span>
                    <span className="font-black text-2xl sm:text-3xl md:text-4xl text-white -mt-1" style={{
                      WebkitTextStroke: '1px rgba(0,0,0,0.9)',
                      paintOrder: 'stroke fill',
                      textShadow: '0 0 8px rgba(255,255,255,0.15), 0 2px 6px rgba(0,0,0,0.7)',
                      fontFamily: "'Arial Black', sans-serif",
                      letterSpacing: '0.08em',
                    }}>genZ</span>
                  </div>

                  {/* Label badge */}
                  <div className="absolute top-4 left-4 pointer-events-none">
                    <span className="inline-block px-3 py-1 rounded-full bg-black/50 backdrop-blur-md border border-[#00FF41]/30 font-mono text-[10px] text-[#00FF41] tracking-wider">{photo.label}</span>
                  </div>
                </div>
              ))}

              {/* Bottom slide label */}
              <div className="absolute bottom-4 left-0 right-0 flex justify-center z-10">
                <div className="flex items-center gap-3 bg-black/60 backdrop-blur-md px-4 py-2 rounded-full border border-white/10">
                  {tshirtGallery.map((photo, idx) => (
                    <button
                      key={idx}
                      data-testid={`tshirt-slide-${idx}`}
                      onClick={() => goToSlide(idx)}
                      className={`transition-all duration-300 rounded-full ${
                        activeSlide === idx
                          ? 'w-8 h-2 bg-[#00FF41]'
                          : 'w-2 h-2 bg-white/30 hover:bg-white/60'
                      }`}
                      aria-label={photo.label}
                    />
                  ))}
                </div>
              </div>

              {/* Prev/Next arrows */}
              <button
                data-testid="tshirt-prev"
                onClick={() => goToSlide((activeSlide - 1 + tshirtGallery.length) % tshirtGallery.length)}
                className="absolute left-3 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-black/50 backdrop-blur border border-white/10 text-white/70 hover:text-[#00FF41] hover:border-[#00FF41]/40 transition-all"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M15 18l-6-6 6-6"/></svg>
              </button>
              <button
                data-testid="tshirt-next"
                onClick={() => goToSlide((activeSlide + 1) % tshirtGallery.length)}
                className="absolute right-3 top-1/2 -translate-y-1/2 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-black/50 backdrop-blur border border-white/10 text-white/70 hover:text-[#00FF41] hover:border-[#00FF41]/40 transition-all"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M9 18l6-6-6-6"/></svg>
              </button>
            </div>

            {/* Info bar */}
            <div className="p-5 text-center border-t border-white/5">
              <p className="font-mono text-[9px] text-[#00FF41] mb-1 tracking-wider">{items[0].belt}</p>
              <h3 className="font-black text-white text-lg mb-1">T-Shirt &lt;/GEN...</h3>
              <p className="text-zinc-500 text-xs">{items[0].desc}</p>
              <p className="text-zinc-600 text-[10px] mt-2 font-mono">Stile All Blacks — Total Black — Esclusiva Soci</p>
            </div>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.slice(1).map((item, i) => (
            <div key={i} data-testid={`merch-item-${i}`}
              className="group bg-[#0A0A0A] border border-zinc-800 overflow-hidden hover:border-[#00FF41]/40 transition-all duration-300 rounded-lg">
              <div className="aspect-square bg-[#111] flex items-center justify-center">
                <span className="text-[#00FF41] font-mono font-black text-4xl opacity-20 group-hover:opacity-50 group-hover:scale-110 transition-all duration-300">&lt;/</span>
              </div>
              <div className="p-4">
                <p className="font-mono text-[9px] text-[#00FF41] mb-1 tracking-wider">{item.belt}</p>
                <h3 className="font-bold text-white text-sm mb-1">{item.name}</h3>
                <p className="text-zinc-500 text-[11px] leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12 space-y-3">
          <Link to="/dona" data-testid="merch-cta-dona" className="zanfa-cta inline-block">
            <WaveText text="Dona e Diventa Socio" />
          </Link>
          <p className="text-zinc-600 text-[10px] font-mono">DONAZIONE + TESSERAMENTO = MERCHANDISING &lt;/</p>
        </div>
      </div>
    </section>
  );
};

export default MerchSection;
